import { VALIDATION_MESSAGE } from '../ValidationMessage';
import { createDateSchema } from './CustomValidation/DateExtendedSchema';
import yup from './CustomValidation/yup-extended';
import { DateSchemaType, ExtendedDateSchemaType } from './ValidationTypes';

export const GradesAndPromotionsValidationSchema = yup.object().shape({
  studentIdentifier: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .mustBeNumber()
    .min(9, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(9))
    .max(9, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(9)),
  studentLastOrSurname: yup.string(),
  studentFirstName: yup.string(),
  district: yup.string(),
  districtName: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  districtId: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .mustBeNumber()
    .min(4, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(4))
    .max(4, VALIDATION_MESSAGE.AT_MOST_CHARS(4)),
  schoolYear: yup.string(),
  schoolId: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  schoolName: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  school: yup.string(),
  promotionStatus: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  highSchoolDiplomaType: yup.string(),
  diplomaOrCredentialAwardDate: (
    (createDateSchema() as ExtendedDateSchemaType).max(
      '2999-12-31',
      VALIDATION_MESSAGE.MUST_BE_VALID_DATE
    ) as ExtendedDateSchemaType
  )
    .max(new Date(), VALIDATION_MESSAGE.EQUAL_TO_OR_EARLIER)
    .when(['highSchoolDiplomaType'], {
      is: (value: string) => value == '' || value == null,
      then: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).notRequired(),
      otherwise: (schema: DateSchemaType) =>
        (schema as ExtendedDateSchemaType).required(
          VALIDATION_MESSAGE.REQUIRED
        ),
    }),
});
